<template>
  <px-lateral-dialog v-model="dialog" width="800" content-class="rounded-card">
    <template v-slot:activator="{ on }">
      <v-btn depressed
             color="success"
             :class="btnClass"
             :small="small"
             :block="block"
             v-on="on">
        Aprovar pedido
      </v-btn>
    </template>
    <template v-slot:title>
      Aprovar pedido
    </template>
    <template>
      <v-row>
        <v-col cols="12">
          <v-textarea
            outlined
            auto-grow
            class="rounded-card-medium"
            label="Mensagem para o comprador"
            counter="1500"
            rows="4"
            v-model="mensagem"
          />
        </v-col>
      </v-row>
    </template>
    <template v-slot:actions>
      <div class="px-3 pb-3 full-width text-right">
        <v-btn depressed class="rounded-tag-small normal-btn-text" @click="close">
          Fechar
        </v-btn>
        <v-btn depressed
               color="primary"
               class="ml-3 rounded-tag-small normal-btn-text"
               :loading="loading"
               @click="onClickAprovar">
          Aprovar
        </v-btn>
      </div>
    </template>
  </px-lateral-dialog>
</template>

<script>
import CompraService from '../compras-service';

export default {
  props: {
    compra: Object,
    btnClass: {
      type: String,
      default: '',
    },
    small: {
      type: Boolean,
      default: true,
    },
    block: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      mensagem: null,
    };
  },
  methods: {
    onClickAprovar() {
      this.aprovar();
    },
    aprovar() {
      this.loading = true;
      CompraService.aprovar(this.compra.id, this.buildCompra())
        .then(() => {
          this.$emit('movimentar');
          this.$toast('Compra aprovada', { color: 'success' });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
    },
    buildCompra() {
      return {
        id: this.compra.id,
        mensagem: this.mensagem,
      };
    },
  },
};
</script>
